import { render, staticRenderFns } from "./product_info_component.vue?vue&type=template&id=0ae03e10&scoped=true"
import script from "./product_info_component.vue?vue&type=script&lang=js"
export * from "./product_info_component.vue?vue&type=script&lang=js"
import style0 from "./product_info_component.vue?vue&type=style&index=0&id=0ae03e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae03e10",
  null
  
)

export default component.exports